module.exports = __webpack_public_path__ + "static/Simon Gyorkos.70bdaa85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Simon Gyorkos.jpg
// module id = 1237
// module chunks = 6166952557895